import axios from "axios";

export default {
	namespaced: true,
	state: () => ({
		allBrand: [],
	}),
	mutations: {
		setAllBrand(state, payload) {
			state.allBrand = payload;
		},
	},
	actions: {
		getAllBrand(context) {
			return axios
				.get("https://main-tw.mini.com.tw/api/mini/getallbrand")
				.then((response) => {
					context.commit("setAllBrand", response.data);
				})
				.catch((error) => {
					console.log(error);
				});
		},
	},
};
